import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-community";

export const useTableData = () => {
	const columnData: ColDef[] = [
		{
			headerName: "Heat",
			field: "HeatName",
			flex: 1,
			minWidth: 70,
			maxWidth: 70,
		},
		{
			headerName: "Last End",
			field: "LastEnd",
			minWidth: 100,
			valueGetter: (params) =>
				params.data.LastEnd
					? dxtToLocalServerTime(params.data.LastEnd, "MMM dd - HH:mm:ss")
					: "",
			flex: 1,
			cellStyle: {
				textAlign: "center",
			},
		},
		{
			headerName: "Start",
			field: "Start",
			minWidth: 100,
			valueGetter: (params) =>
				params.data.Start
					? dxtToLocalServerTime(params.data.Start, "MMM dd - HH:mm:ss")
					: "",
			flex: 1,
			cellStyle: {
				textAlign: "center",
			},
		},
		{
			headerName: "End",
			field: "End",
			minWidth: 100,
			valueGetter: (params) =>
				params.data.End
					? dxtToLocalServerTime(params.data.End, "MMM dd - HH:mm:ss")
					: "",
			flex: 1,
			cellStyle: {
				textAlign: "center",
			},
		},
		{
			headerName: "Next Start",
			field: "NextStart",
			minWidth: 100,
			valueGetter: (params) =>
				params.data.NextStart
					? dxtToLocalServerTime(params.data.NextStart, "MMM dd - HH:mm:ss")
					: "",
			flex: 1,
			cellStyle: {
				textAlign: "center",
			},
		},
		{
			headerName: "Shift",
			field: "Shift",
			minWidth: 80,
			maxWidth: 80,
			cellStyle: {
				textAlign: "center",
			},
			flex: 1,
		},
		{
			headerName: "Crew",
			field: "Crew",
			minWidth: 80,
			maxWidth: 80,
			cellStyle: {
				textAlign: "center",
			},
			flex: 1,
		},
	];

	const defaultColDef: ColDef = {
		flex: 1,
		resizable: true,
	};

	return { columnData, defaultColDef };
};
